/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Typography, Grid, Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { serviceValue } from 'src/config'
import { maskCurrency } from 'src/utils/formatNumber'
import { calcValuesByHa } from 'src/utils/utils';

export default function BudgetCollapses({ study }: any) {
	const [totalValue, setTotalValue] = useState(0);
	const [optionsValue, setOptionsValue] = useState({
		completeEvu: 0,
		directorPlan: 0,
		concept: 0,
		dwgStudy: 0,
		downloadStudy: 0
	});

	useEffect(() => {
		if (study) {
			const haValue = parseFloat(study.area ? study?.area?.replace(/[^\d.]/g, '') : '0');
			var values = [];
			if (study?.selectedOptions?.completeEvu === true) {
				if(study?.optionsValue?.completeEvu) {
					values.push(study?.optionsValue?.completeEvu);
				} else {
					values.push(calcValuesByHa(haValue, "completeEvu"));
				}
			}
			if (study?.selectedOptions?.concept === true) {
				if(study?.optionsValue?.concept) {
					values.push(study?.optionsValue?.concept);
				} else {
					values.push(calcValuesByHa(haValue, "concept"));
				}
			}
			if (study?.selectedOptions?.directorPlan === true) {
				if(study?.optionsValue?.directorPlan) {
					values.push(study?.optionsValue?.directorPlan);
				} else {
					values.push(calcValuesByHa(haValue, "directorPlan"));
				}
			}
			if (study?.selectedOptions?.dwgStudy === true) {
				if(study?.optionsValue?.dwgStudy) {
					values.push(study?.optionsValue?.dwgStudy);
				} else {
					values.push(calcValuesByHa(haValue, "dwgStudy"));
				}
			}
			if (study?.selectedOptions?.georeferencing === true) {
				values.push(serviceValue['georeferencing']);
			}
			if (study?.selectedOptions?.downloadStudy === true) {
				if(study?.optionsValue?.downloadStudy) {
					values.push(study?.optionsValue?.downloadStudy);
				} else {
					values.push(calcValuesByHa(haValue, "downloadStudy"));
				}
			}
			const total = values.reduce((prev, current) => prev + current, 0);
			setTotalValue(total);
			setOptionsValue({
				completeEvu: study?.optionsValue?.completeEvu || calcValuesByHa(haValue, "completeEvu"),
				directorPlan: study?.optionsValue?.directorPlan || calcValuesByHa(haValue, "directorPlan"),
				concept: study?.optionsValue?.concept || calcValuesByHa(haValue, "concept"),
				dwgStudy: study?.optionsValue?.dwgStudy || calcValuesByHa(haValue, "dwgStudy"),
				downloadStudy: study?.optionsValue?.downloadStudy || calcValuesByHa(haValue, "downloadStudy")
			});
		}
	}, []);

	const RowComponent = ({ label, value }: any) => <Grid container direction={'row'} ml={-1} mb={2} spacing={4}>
		<Grid item xs={9}>
			<Typography>{label}</Typography>
		</Grid>
		<Grid item xs={3}>
			<Typography>{maskCurrency(value)}</Typography>
		</Grid>
	</Grid>

	const services: Record<string, JSX.Element> = {
		'completeEvu': <RowComponent label={'EVU Completo'} value={optionsValue.completeEvu}/>,
		'concept': <RowComponent label={'Concept'} value={optionsValue.concept}/>,
		'directorPlan': <RowComponent label={'Análise territorial'} value={optionsValue.directorPlan}/>,
		'dwgStudy': <RowComponent label={'Anteprojeto'} value={optionsValue.dwgStudy}/>,
		'georeferencing': <RowComponent label={'Georreferenciamento'} value={serviceValue['georeferencing']}/>,
		'downloadStudy': <RowComponent label={'Download do (.dxf)'} value={optionsValue.downloadStudy}/>
	}

	return <Card>
		<Grid container direction={'column'} xs={12}>
			<Box m={2} bgcolor={'#F4F6F8'} borderRadius={2} height={50}>
				<Grid container direction={'row'} mt={1.5}>
					<Grid item xs={8} alignItems={'center'} spacing={2}>
						<Typography color={'#637381'} textAlign='center' mr={15}>
							<b>Serviços contratados</b>
						</Typography>
					</Grid>
					<Grid item xs={4} alignItems={'center'}>
						<Typography color={'#637381'} textAlign='center'>
							<b>Valor</b>
						</Typography>
					</Grid>
				</Grid>
			</Box>
			<Box m={2}>
				{study?.selectedOptions.directorPlan === true ? services['directorPlan'] : <></>}
				{study?.selectedOptions.completeEvu === true ? services['completeEvu'] : <></>}
				{study?.selectedOptions.concept === true ? services['concept'] : <></>}
				{study?.selectedOptions.dwgStudy === true ? services['dwgStudy'] : <></>}
				{study?.selectedOptions.georeferencing === true ? services['georeferencing'] : <></>}
				{study?.selectedOptions.downloadStudy === true ? services['downloadStudy'] : <></>}
			</Box>
			<Box m={2}>
				<Grid container direction={'row'} ml={-1} spacing={4}>
					<Grid item xs={9}>
						<Typography>
							<b>Total</b>
						</Typography>
					</Grid>
					<Grid item xs={3}>
						<Typography>
							<b>{maskCurrency(totalValue)}</b>
						</Typography>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	</Card>
}
